module.exports = __webpack_public_path__ + "static/media/2.d89a6b98.svg";